import { isCustomChartTypeSlugChartConfig } from '../../../schemas';
import { AiResultType } from '../../../types';
export const getGroupByDimensions = (args) => {
    switch (args.type) {
        case AiResultType.QUERY_RESULT: {
            const chartConfig = args.vizTool?.chartConfig;
            if (isCustomChartTypeSlugChartConfig(chartConfig))
                return undefined;
            return chartConfig?.groupBy ?? undefined;
        }
        case AiResultType.VERTICAL_BAR_RESULT:
        case AiResultType.TIME_SERIES_RESULT:
            return args.vizTool?.vizConfig.breakdownByDimension
                ? [args.vizTool.vizConfig.breakdownByDimension]
                : undefined;
        default:
            return undefined;
    }
};
//# sourceMappingURL=getGroupByDimensions.js.map